import {
    GET_SINGLEPOST_REQUEST,
    GET_SINGLEPOST_SUCCESS,
    GET_SINGLEPOST_FAILURE,
} from "../const";


const initialState = [
        {
            image: null,
            date: null,
            category:[],
            code: null
        },

    ]

const handlers = {
    [GET_SINGLEPOST_REQUEST]: () => ({ ...initialState, load: false}),
    [GET_SINGLEPOST_SUCCESS]: (state, { payload: { OnePost } }) => ({
        ...state,
        load: true,
        ...OnePost
        
    }),
    [GET_SINGLEPOST_FAILURE]: (state) => ({ ...state, loading: false }),
    DEFAULT: (state) => state,
};

const singlePostReducer = (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};

export default singlePostReducer;